module.exports = __webpack_public_path__ + "static/media/login-blue.ef5867b5.png";